// assets/blog-category.js
document.addEventListener('DOMContentLoaded', function() {
  console.log('Blog category JS loaded');

  // ===== SORT ARTICLES BY NUMBER =====
  // Find all resource lists and sort their items
  var resourceLists = document.querySelectorAll('.blog-category-list__list');
  
  resourceLists.forEach(function(list) {
    var items = list.querySelectorAll('li');
    
    if (items.length > 1) {
      // Convert NodeList to array for sorting
      var itemsArray = Array.from(items);
      
      // Sort by extracting the number from the article title
      itemsArray.sort(function(a, b) {
        var titleA = a.textContent.trim();
        var titleB = b.textContent.trim();
        
        // Extract numbers like 01, 02, 03 from the title
        var numberA = extractNumber(titleA);
        var numberB = extractNumber(titleB);
        
        return numberA - numberB;
      });
      
      // Clear the list
      list.innerHTML = '';
      
      // Append sorted items
      itemsArray.forEach(function(item) {
        list.appendChild(item);
      });
    }
  });
  
  // Function to extract number from article title
  function extractNumber(title) {
    // Look for patterns like 1C-01, 2Q-10, etc.
    var match = title.match(/-(\d+)/);
    if (match) {
      return parseInt(match[1], 10);
    }
    
    // If no match, try to find any number in the title
    var numberMatch = title.match(/\b(\d+)\b/);
    if (numberMatch) {
      return parseInt(numberMatch[1], 10);
    }
    
    // Default: return a large number to put at the end
    return 9999;
  }

  // ===== SECTION GROUPING LOGIC =====
  var items = document.querySelectorAll('.blog-category-list__item');
  console.log('Found ' + items.length + ' section cards');

  var excludeList = ['Join Us', 'Subscribe', 'Newsletter', 'Follow us', 'Sign up'];

  items.forEach(function(item, index) {
    var sectionTag = item.dataset.sectionTag;
    var list = item.querySelector('.blog-category-list__list');
    var countElement = item.querySelector('.blog-category-list__count');

    if (!list) return;

    console.log('Section ' + index + ': ' + sectionTag);
  });

  // ===== Click tracking for analytics =====
  items.forEach(function(item) {
    var links = item.querySelectorAll('.blog-category-list__list a');
    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var sectionTag = item.dataset.sectionTag;
        console.log('Clicked article: ' + link.textContent + ' from section: ' + sectionTag);
        // You can add analytics tracking here
      });
    });
  });
});